import {transform,} from 'ol/proj';
import ImageLayer from "ol/layer/Image";
import {ImageWMS} from "ol/source";
import {convertLayerUrl} from "@/helpers/url-helper";
import {createGeoJsonLayer, getDefaultName} from "@/helpers/geo-json-helper";
import {loadMapClick} from "@/helpers/ol-event-helper";
import {generateCanvas} from "@/helpers/canvas-helper";
import {loadMeteo} from "@/meteo-helper";

export function removeLayer(name) {
    if(window.map) {
        window.map.getLayers().forEach(layer => {
            if (layer && layer.get('name') === name) {
                window.map.removeLayer(layer);
            }
        });
    }
}

export function getLayerByName(name) {
    let selectedLayer = undefined
    window.map.getLayers().forEach(layer => {
        if (layer && layer.get('name') === name) {
            selectedLayer = layer
        }
    });
    return selectedLayer
}

export function getGeometryByLayerName(name, transformDestination = 'EPSG:28992') {
    const layer = getLayerByName(name)
    if(!layer) {
        return layer
    }
    const feature = layer.getSource().getFeatures()[0]
    return transform(feature.getGeometry().flatCoordinates, 'EPSG:3857', transformDestination)
}

export function refreshLayerByName(layer) {
    if(window.map) {
        removeLayer(layer.Layer)
        window.map.addLayer(new ImageLayer({
            name: layer.Layer,
            zIndex: 10,
            source: new ImageWMS({
                url: convertLayerUrl(layer.Url) + 'time=' + new Date().getTime(),
                projection: layer.Service.Projection,
                params: {
                    'LAYERS': layer.Layer,
                    'TILED': false
                },
                transition: 0,
            }),
        }))
    }
}

export function setLayerClick(coordinate) {

    if(window.categoryNameLinked !== undefined) {
        return
    }

    removeLayer(getDefaultName())

    const feature = {}
    feature.geometry = {}
    feature.geometry.type = 'Point'
    feature.geometry.coordinates = coordinate

    createGeoJsonLayer(feature, true, false)
    loadMapClick(coordinate)


    generateCanvas()
    loadMeteo(coordinate)
}

export function updateMapSize() {
    if(window.map) {
        window.map.updateSize()
    }
}
